import { useState, useEffect } from "react";
import { IMAGE_PLACEHOLDER } from "@/constants/global";
import { storage } from "@/firebase";

export const useOriginalImage = (file?: string | string[], organizationId?: string) => {
  const [imageUrl, setImageUrl] = useState<string>(IMAGE_PLACEHOLDER);

  useEffect(() => {
    if (!file || !organizationId) {
      setImageUrl(IMAGE_PLACEHOLDER);
      return;
    }

    const fileName = Array.isArray(file) ? file[0] : file;

    if (fileName.startsWith("http://") || fileName.startsWith("https://")) {
      setImageUrl(fileName);
      return;
    }

    import("firebase/storage").then(({ ref, getDownloadURL }) => {
      const fileRef = ref(storage, `images/organizations/${organizationId}/${fileName}`);
      getDownloadURL(fileRef)
        .then((url) => setImageUrl(url))
        .catch((error) => {
          console.error("Error fetching original image download URL:", error);
          setImageUrl(IMAGE_PLACEHOLDER);
        });
    });
  }, [file, organizationId]);

  return imageUrl;
};

export default useOriginalImage;
